import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appHighlightLetters]'
})
export class HighlightLettersDirective implements OnInit {
  @Input('appHighlightLetters') positions: number[] = [];
  @Input() text: string = '';
  @Input() highlightColor: string = '#472fdf';

  constructor(private el: ElementRef) { }

  ngOnInit() {
    if (!this.text) return;

    const highlightedText = this.text.split('').map((char, index) => {
      if (this.positions.includes(index)) {
        return `<span style="color: ${this.highlightColor}">${char}</span>`;
      }
      return char;
    }).join('');

    this.el.nativeElement.innerHTML = highlightedText;
  }
}